


















































































































































import { Component, Vue, Watch, Prop, Mixins } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import MyImage from '@/components/image/index.vue';
import MixinCertification from '@/mixins/certification';
@Component({
  components: {
    MyImage,
  },
})
export default class Certification extends Mixins(MixinCertification) {

  @Prop({ type: Object, default() { return {}; } })
  protected data!: TypeCertification.CustomerStartupInfo;
  /** 成功回调 */
  @Prop({ type: Function, default: () => ({}) })
  private onSuccess!: (isPool?: boolean) => void;
  @Watch('data', { immediate: true })
  protected onDataChange(data: TypeCertification.CustomerStartupInfo): void {
    if (data.certification_info && data.certification_info.is_agent !== null) {
      const formData = this.$util.deepCopy(data.certification_info);
      for (const key in formData) {
        if (formData[key]) {
          this.formData[key] = formData[key];
        }
      }
      this.formData.id_card_number = formData.certification_id_card_number as string;
      if (!this.formData.phone_number) {
        if (data.sign_body_info) {
          this.formData.phone_number = data.sign_body_info.phone_number;
        }
      }
      if (!this.formData.name) {
        if (data.sign_body_info) {
          this.formData.name = data.sign_body_info.contact_name;
        }
      }
      if (data.sign_body_info) {
        this.formData.account_code = data.sign_body_info.account_code as string;
        this.formData.credit_code = data.sign_body_info.credit_code;
      }
    } else {
      this.formData = this.initFormData();
      this.formData.account_code = data.sign_body_info?.account_code as string;
      this.formData.certification_type = Number(data.sign_body_info?.type);
      this.formData.company_name = data.sign_body_info?.sign_body_name as string;
      this.formData.credit_code = data.sign_body_info?.credit_code as string;
      this.formData.name = data.sign_body_info?.contact_name as string;
      this.formData.phone_number = data.sign_body_info?.phone_number as string;
    }
  }
  protected get isCN(): boolean {
    if (this.data.sign_body_info) {
      return this.data.sign_body_info.register_area_code === 'CN';
    } else {
      return true;
    }
  }
  /**
   * @description: 提交认证信息
   * @return {*}
   */
  public handleSubmit(): void {
    const h = this.$createElement;
    const formDataRef = this.$refs.formDataRef as FormModel;
    formDataRef.validate(async (valid: boolean) => {
      if (valid) {
        const data = await this.saveAuthorizationInfo(this.formData);
        if (data) {
          if (data.certification_url) {
            const text = this.$util.getEnumTextByValue(this.certificationTypeEnum, this.formData.certification_type);
            this.certificationUrl = data.certification_url;
            this.$confirm({
              title: this.tc('温馨提示'),
              content: (
                <p>
                  <span style='font-weight: 600'>{this.t('您还未完成' + text)}</span>
                  <p class='zt-dialog-tip-text'>
                    {this.t('请前往新窗口完成') + text + this.t('，完成后您的主体实名认证状态变更为已实名认证。')}
                  </p>
                </p>
              ),
              okText: this.t('前往' + text),
              onOk: () => {
                this.openCertificationUrl();
                this.visible = false;
                typeof this.onSuccess === 'function' && this.onSuccess(true);
              },
            });
          } else {
            this.visible = false;
            typeof this.onSuccess === 'function' && this.onSuccess();
          }
        }
      }
    });
  }


}
